/**
 * Maps User-GetById payload to a country list option id for profile Select fields.
 * API often returns countryName while countryOfBirth / countryOfCitizenship are 0.
 */
export function resolveCountryIdFromUser(userData, countries) {
  if (!userData || !Array.isArray(countries) || countries.length === 0) {
    return undefined;
  }

  const matchId = (id) => {
    const num = Number(id);
    if (!num) return undefined;
    const found = countries.find((c) => c.id === num || c.value === num);
    return found ? (found.id ?? found.value) : undefined;
  };

  const fromBirth = matchId(userData.countryOfBirth);
  if (fromBirth) return fromBirth;

  const fromCitizenship = matchId(userData.countryOfCitizenship);
  if (fromCitizenship) return fromCitizenship;

  const name = String(userData.countryName || "").trim().toLowerCase();
  if (!name) return undefined;

  const found = countries.find(
    (c) =>
      String(c.countryName || c.label || "")
        .trim()
        .toLowerCase() === name
  );
  return found?.id ?? found?.value;
}
